import api from "./api";

var queryString = (params) => {
  return Object.keys(params)
    .map((key) => key + "=" + params[key])
    .join("&");
};


export const getAccountTypes = (params) => {
  return api.get("/v1/cp/account-types?");
};

export const getOtherTypes = (params) => {
  return api.get("/v1/cp/account-types/others?" + queryString(params));
};

export const createLiveAccount = (params) => {
  return api.post("/v1/cp/accounts/", params);
};
export const getTradingAccounts = (params) => {
  return api.get("/v1/cp/accounts/", params);
};

export const getLiveAccounts = (params) => {
  return api.get("/v1/cp/accounts/live-accounts?" + queryString(params));
};

/*export const getOpenPositions = (id,page,limit) => {
  return api.get("/v1/cp/accounts/" + id + "/open-positions");
};*/
export const getOpenPositions = (id, page, limit) => {
  return api.get(`/v1/cp/accounts/${id}/open-positions?page=${page}&limit=${limit}`);
};
export const getClosePosition = (id, page, limit) => {
  return api.get(`/v1/cp/accounts/${id}/close-positions?page=${page}&limit=${limit}`);
};
export const postChangePassword = (id, params) => {
  return api.post("/v1/cp/accounts/" + id + "/change-password-otp", params);
};

export const gtnPaawordChange = async (params) => {
  return api.post("/v1/gtn/account/gtnPassChange", params);
}
